import SystemTableNav from 'components/Layout/SystemTableNav/SystemTableNav';

export default SystemTableNav;
